/*
 * @Descripttion: 
 * @version: v1.0
 * @Author: wangxiaoyun
 * @Date: 2024-04-28 14:08:31
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-09-18 18:04:27
 */
import Vue from "vue"
import Vuex from "vuex"
import getCookie from '@/assets/js/getCookie.js';

Vue.use(Vuex)
const store = new Vuex.Store({
	state: { // 相当于data
		token:  '', // token
		imgUrl: 'https://qdeh.com.cn',// 'https://qdeh.com.cn', // 'http://www.qdeh.com.cn', // 公共图片 http://192.168.100.170:9913
		axiosUrl: 'https://qdeh.com.cn', // 'https://qdeh.com.cn', // 'https://api.qdeh.com.cn', // http://120.221.19.40:81
		// axiosUrl:'http://192.168.1.244:9913',
		dialogShow:false,//登录注册弹窗开关
		dialogToggle:1,//登录注册样式切换1登录 2 注册
		chatShow:false,//聊天dialog
		pid:0,//聊天id
		editPwd: 0, // 0: 关闭；1: 修改密码；2: 修改用户信息；
		userInfo: {}, // 用户信息；
		userDeptInfo:{},//企业相关信息
		scrollTop:''//首页滚动高度
	},
	getters: { // 相当于computed
		token (state) {
			return state.token
		},
		imgUrl (state) {
			return state.imgUrl
		}, 
		axiosUrl (state) {
			return state.axiosUrl
		}, 
		editPwd (state) {
			return state.editPwd
		},
		userInfo (state) {
			return state.userInfo
		},
		userDeptInfo (state) {
			return state.userDeptInfo
		},
		scrollTop (state) {
			return state.scrollTop
		},
	},
	mutations: { // 相当于methods
		setToken (state, payload) {
			sessionStorage.setItem("token",payload)
			state.token = payload
		},
		changeDialog(state,payload){
			state.dialogShow= payload
		},
		changeToggle(state,payload){
			state.dialogToggle= payload
		},
		changechatShow(state,payload){
			state.chatShow= payload
		},
		changePid(state,payload){
			state.pid= payload
		},
		changeScrollTop(state,payload){
			state.scrollTop= payload
		},
		editPwd (state, payload) {
			sessionStorage.setItem("editPwd",payload)
			state.editPwd = payload
		},
		userInfo (state, payload) {
			sessionStorage.setItem("userInfo", JSON.stringify(payload))
			state.userInfo = payload
		},
		userDeptInfo(state, payload) {
			sessionStorage.setItem("userDeptInfo", JSON.stringify(payload))
			state.userDeptInfo = payload
		}
	},
	actions: { // 可以同时执行多个mutations方法
		getToken ({commit}, payload) {
			commit("setToken", payload)
		},
		getEditPwd ({commit}, payload) {
			commit("editPwd", payload)
		},
		getUserInfo ({commit}, payload) {
			commit("userInfo", payload)
		},
		getUserDeptInfo({commit}, payload) {
			commit("userDeptInfo", payload)
		},
	}
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js